import { useEffect, useState } from "react";
import { apiLoadingStore } from "../util/loadingStore";

export function useApiLoading() {
  const [loadingState, setLoadingState] = useState({
    isLoading: false,
    activeRequests: 0,
  });

  useEffect(() => {
    return apiLoadingStore.subscribe((isLoading, activeRequests) => {
      setLoadingState({ isLoading, activeRequests });
    });
  }, []);

  return loadingState;
}